import React from 'react';
import { Flex, Button } from 'rebass';
import styled from 'styled-components';
import { RECRUITER } from 'constants/index';
import { format } from 'date-fns';
import UserStatusDropDown from './UserStatusDropDown';

const Table = styled.table`
  width: 100%;
`;

const TH = styled.th`
  padding: 20px 0;
`;

const TD = styled.td`
  text-align: center;
  padding: 15px 0;
`;

const UserLink = styled(Button)`
  font-size: 16px;
  text-decoration: underline;
`;

const UsersList: React.FC<any> = ({ list, userRoleType, userLinkHandler }): JSX.Element => (
  <Flex width="100%" my={5}>
    <Table>
      <tbody>
        <tr>
          <TH>ID</TH>
          <TH>Contact Person</TH>
          <TH>Email</TH>
          {userRoleType === RECRUITER && <TH>Recruiting Licence</TH>}
          <TH>Company Name</TH>
          <TH>Phone Number</TH>
          <TH>Registration</TH>
          <TH>Status</TH>
        </tr>
        {list.map((user: any) => (
          <tr key={user.id}>
            <TD>{user.id}</TD>
            <TD>
              <UserLink variant="navigation" onClick={() => userLinkHandler(user.email)}>
                {user.info.contactPerson}
              </UserLink>
            </TD>
            <TD>{user.email}</TD>
            {userRoleType === RECRUITER && <TD>{user.info.recruitingLicence}</TD>}
            <TD>{user.info.companyName}</TD>
            <TD>{user.info.phoneNumber}</TD>
            <TD>{format(new Date(user.createdAt), 'MM.DD.YYYY  h:mma')}</TD>
            <TD>
              <UserStatusDropDown userId={user.id} userStatus={user.status} userRole={user.role} />
            </TD>
          </tr>
        ))}
      </tbody>
    </Table>
  </Flex>
);

export default UsersList;
